import { Stack, StackProps, styled } from '@mui/material';
import Button from '../../../../../../../../components/Button';

export const Content = styled((props: StackProps) => <Stack flex={1} gap={2} {...props} />)(({ theme }) => ({
  overflow: 'hidden',
  color: theme.palette.common.black,
}));

export const DrawerButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(2.25, 4.75),
  minHeight: 'unset',
}));
